<template>
  <div class="container-fluid  rol-body">
      <div class = "row m-3 pb-2 pt-3 ">
        <router-link @click.native="setRole('Cargador')" :disabled = "!authorized('cargador')"  tag="button"  class="btn-general btn-rol  ml-auto mr-auto " to="mainmenu" exact>
            CARGADOR 
            <!-- <span>        
              <img class ='icons-alert' :src="require('@/assets/icons/bell.svg')" alt="bell icon"/>
            </span> -->
        </router-link>
      </div>
      <div class = "row  m-3  pb-2">
        <router-link @click.native="setRole('Transitario')" :disabled = "!authorized('transitario')" tag="button"  class="btn-general btn-rol  ml-auto mr-auto" to="mainmenu" exact>
            TRANSITARIO
        </router-link>
      </div>
      <div class = "row  m-3  pb-2">
        <router-link @click.native="setRole('Terminal')" :disabled = "!authorized('terminal')"  tag="button"   class="btn-general btn-rol  ml-auto mr-auto" to="mainmenu" exact>
            TERMINAL
        </router-link>
      </div>
      <div class = "row  m-3 pb-2 ">
        <router-link @click.native="setRole('Transportista')" :disabled = "!authorized('transportista')" tag="button"  class="btn-general btn-rol  ml-auto mr-auto" to="mainmenu" exact>
            TRANSPORTISTA
        </router-link>
      </div>
      <div class = "row  m-3 pb-2 ">
        <router-link @click.native="setRole('Consignatario')" :disabled = "!authorized('consignatario')"  tag="button"  class="btn-general btn-rol  ml-auto mr-auto" to="mainmenu" exact>
            CONSIGNATARIO
        </router-link>
      </div>
      <div class = "row  m-3 ">
        <router-link @click.native="setRole('Validador Genérico')" :disabled = "!authorized('validador_generico')"   tag="button" class="btn-general btn-rol  ml-auto mr-auto" to="mainmenu" exact>
            VALDADOR GENÉRICO
        </router-link>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SelectRole',
  data(){
    return {
        disabled: true,
     }
  },
  computed: { 
    ...mapGetters("user",{
      authorized: 'authorized',
    })  
  },
  mounted () {
    this.$store.commit('set_view_name', ['Selección de rol'])
    this.$store.commit('set_view_role', ['Aureal'])
  },
  methods: {
    setRole: function (role) {
      this.$store.commit('set_view_role', [role])
    }
  }
}
</script>

<style lang= "scss" scoped>

.rol-body > .row > img {
    height: 100%;
    margin-top: 25px;
    margin-bottom: 25px;
    max-width: 150px;
    margin-left: auto;
    margin-right: auto; 
}

.Transitario{border-left-color: $Transitario !important}
.Consignatario{border-left-color: $Consignatario !important}
.Terminal{border-left-color: $Terminal !important}
.Transportista{border-left-color: $Transportista !important}

</style>
